import { useMutation, useQueryClient } from "@tanstack/react-query"
import axios from "axios"
import { ConversationResponseDataSchema, DataResponse, ToggleAISchema } from "schema"
import { z } from "zod"
import { getConversationTimelineQueryKey } from "../lib/conversationTimelineQuery"

type Params = z.infer<typeof ToggleAISchema>
type Response = DataResponse<z.infer<typeof ConversationResponseDataSchema>>

export function useToggleConversationAIMutation(conversationId: string) {
  const queryClient = useQueryClient()

  return useMutation<Response, Error, Params>({
    mutationFn: async (params) => {
      const response = await axios.patch<Response>(
        `/conversations/${conversationId}/toggle-ai`,
        params,
      )
      return response.data
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: getConversationTimelineQueryKey(conversationId),
      })
      await queryClient.invalidateQueries({ queryKey: ["conversations"] })
    },
  })
}
